/* eslint-disable */
import { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import { Button, Modal, CardContent, TextField } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById, patchEquipmentRemark } from "components/axios/equipmentAxios";
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import Chip from '@mui/material/Chip';
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const EquipmentRemarkModifyLayer = ({equipmentId, onRefresh}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { role } = useEnumApi();
    const [remark, setRemark] = useState(null);
    const { register, handleSubmit, formState : {isDirty, errors } } = useForm({});
    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    const onSubmit = (data) => {
        if (equipmentId) {
            const body = {
                id : equipmentId,
                remark : data.remark
            }

            openModal(modals.confirmModal, {
                onSubmit : (value) => {
                    patchEquipmentRemark(body).then(()=>{
                        handleAlertClick(t('message.common.alert.modify.done'));
                        onRefresh();
                        handleClose();
                    }).catch((err)=>{
                        console.log(err);
                        handleAlertClick(err.response?.data?.message || err.message);
                    });
                },
                onClose : () => {
                    console.log('close');
                },
                message: t('message.common.alert.modify.question'),
            });
        }
    }

    useEffect(() => {
        if (equipmentId) {
            getEquipmentsById(equipmentId).then((data)=>{
                if (data) {
                    setRemark(data.remark);
                } else {
                    setRemark(null);
                }
            })
        }
    },[equipmentId]);

    // if (equipmentId && (role === ROLE.SA.code || role === ROLE.WA.code || role === ROLE.MA.code)) { 
    if (equipmentId) {
        return (
            <>
                <div style={{minWidth:"100px",margin:"auto"}}>
                    <PermissionButton
                    permission={PERMISSIONS.EQUIPMENT_REMARK_MODIFY}
                    className="pop_style_btn"
                    type="button"
                    onClick={handleOpen}
                    style={{
                        height: "35px",
                        minHeight: "35px"
                    }}
                    >
                        <span>{t('message.common.btn.modify')}</span>

                        <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            style={{
                            display: "block",
                            flexShrink: 0
                            }}
                        >
                            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.375 2.625a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" />
                        </svg>
                    </PermissionButton>
                </div>
                <Modal
                    className="pop_box pop_box1 renew_pop_box remark_renew_pop"
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="remark-modal-title"
                    aria-describedby="remark-modal-description"
                >
                    <MainCard modal darkTitle content={false} sx={{ width: 640, maxWidth: 'calc(100vw - 32px)' }}>
                        <div className="modal-header remark_modal_header" id="remark-modal-title">
                            <span className="remark_modal_title_icon" aria-hidden="true">📝</span>
                            <span className="remark_modal_title_text">{t('message.common.chip.remark.modify')}</span>
                        </div>

                        <CardContent className="remark_modal_content">
                            <div className="remark_modal_notice" id="remark-modal-description">
                                {t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <TextField
                                    id="outlined-basic"
                                    aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                    defaultValue={remark || ''}
                                    multiline
                                    rows={3}
                                    fullWidth
                                    {...register("remark", {
                                        required: t('message.common.error.text.remark.input')
                                    })}
                                />
                                {errors.remark && <small className="remark_modal_error" role="alert">{errors.remark.message}</small>}
                            </form>
                        </CardContent>

                        <div className="remark_modal_footer">
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="remark_modal_submit"
                                onClick={handleSubmit(onSubmit)}
                            >
                                {t('message.common.btn.modify')}
                            </Button>
                            <Button
                                variant="contained"
                                className="remark_modal_close"
                                size="small"
                                onClick={handleClose}
                            >
                                {t('message.common.btn.close')}
                            </Button>
                        </div>
                    </MainCard>
                </Modal>
                </>
        )
    }
}

export default EquipmentRemarkModifyLayer;